// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-1rqSg_o9","sider":"sider-HivAmDdv","stock_box":"stock_box-Y8duuIN6 clearfix","sider_list":"sider_list-2qtBR7K4"};